import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { removeMembership } from "../../api/memberships";
import Loader from "../../component/Loader";
import DeleteModal from "../../component/Modal/Delete";
import { pageTransitionVariant, variants } from "../../constant/Variants";
import Select from "react-select";
import {
  fetchMembershipList,
  membershipListSelector,
  totalMembershipSelector,
} from "./MembershipSlice";
import { getTeacherId } from "../../app/globalStore";

function Membership() {
  const dispatch = useDispatch();
  const list = useSelector(membershipListSelector);
  const total = useSelector(totalMembershipSelector);
  const teacher_id = getTeacherId();
  
  // Restore pagination state from sessionStorage on component mount
  const [search, setSearch] = useState(() => {
    return sessionStorage.getItem('membershipListSearch') || "";
  });
  const [show, setShow] = useState(false);
  const [delId, setDelId] = useState("");
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem('membershipListPage');
    return savedPage ? parseInt(savedPage) : 1;
  });
  const [loading, setLoading] = useState(false);
  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          { value: 0, label: 'All Companies' },
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  // Restore company selection state from sessionStorage on component mount
  const [selectedCompany, setSelectedCompany] = useState(() => {
    const savedCompany = sessionStorage.getItem('membershipListCompany');
    return savedCompany ? parseInt(savedCompany) : 0;
  });
  const handleShow = () => {
    setShow(!show);
  };

  const getList = useCallback(() => {
    setLoading(true);
    dispatch(
      fetchMembershipList({ page: page, limit: 10, search: search, company_id : selectedCompany })
    ).then(() => {
      setLoading(false);
    });
  }, [dispatch, page, search, selectedCompany]);

  useEffect(() => {
    getList();
  }, [getList]);

  // Save page state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('membershipListPage', page.toString());
  }, [page]);

  // Save search state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('membershipListSearch', search);
  }, [search]);

  // Save company selection state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('membershipListCompany', selectedCompany.toString());
  }, [selectedCompany]);

  const confirmDelete = () => {
    removeMembership({ membership_id: delId }).then((res) => {
      if (res?.code === 1) {
        toast.success(res?.message);
        getList();
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/memberships-selected.png" alt="" />{" "}
                total memberships {total}
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search membership by name"
                  value={search}
                  onChange={(e) => {
                    setPage(1);

                    setSearch(e.target.value);
                  }}
                />
              </form>
              <Link to="/add-membership" className="">
                <img
                  src="assets/images/addBtn.png"
                  alt=""
                  className="add-new"
                />
              </Link>
            </div>
          </div>
        </div>
        {Array.isArray(companyOptions) && companyOptions.length > 0 && (
        <div className="row mt-3">
        <div className="col-sm-12 col-md-12 col-lg-4">
            <Select
                options={companyOptions}
                isSearchable
                placeholder="Select a company..."
                value={companyOptions.find(option => option.value === selectedCompany)}
                onChange={option => {
                  setSelectedCompany(option.value);
                }}
              />
            </div>
        </div>
        )}
        <div className="row mt-3">
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Photo</th>
                    <th scope="col">Membership name</th>
                    <th scope="col">category</th>
                    {/* <th scope="col">total members</th> */}
                    <th scope="col">Price</th>
                    <th scope="col">About</th>
                    <th scope="col">Duration</th>
                    <th scope="col">Action</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <td colSpan={8}>
                      <Loader />
                    </td>
                  ) : list?.length > 0 ? (
                    list?.map((item, i) => {
                      return (
                        <tr key={i} variants={variants.card}>
                          <td>{item?.id || "NA"}</td>

                          <td>
                            <img
                              src={
                                item?.image?.includes("http")
                                  ? item?.image
                                  : "assets/images/headerlogo.png"
                              }
                              className="table-img"
                              alt=""
                            />
                          </td>
                          <td>{item?.name || "NA"}</td>
                          <td>{item?.student_type || "NA"}</td>
                          {/* <td>40</td> */}
                          <td>
                            <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {item?.total_price
                              ? item?.total_price
                              : item?.student_type === "adult"
                              ? item?.adult_price
                              : item?.student_type === "child"
                              ? item?.child_price
                              : "NA"}
                          </td>
                          <td>{item?.about || "NA"}</td>
                          <td>
                            {item?.no_of_days === 1
                              ? `${item?.no_of_days} day`
                              : item?.no_of_days > 1
                              ? `${item?.no_of_days} days`
                              : "NA"}
                          </td>
                          <td>
                            <div className="d-flex justify-content-center action">
                              <button className="btn" title="View">
                                <Link to={`/membership/${item?.id}`}>
                                  <img src="assets/images/view.png" alt="" />
                                </Link>
                              </button>
                              <button className="btn" title="Edit">
                                <Link to={`/edit-membership/${item?.id}`}>
                                  <img src="assets/images/edit.png" alt="" />
                                </Link>
                              </button>
                              {teacher_id === 0 && (
                              <button
                                className="btn"
                                onClick={() => {
                                  handleShow();
                                  setDelId(item?.id);
                                }}
                                title="Delete"
                              >
                                <img src="assets/images/delete.png" alt="" />
                              </button>
                              )}
                              {/* <button className="btn">
                                  <input
                                    type="checkbox"
                                    className="toggle"
                                    checked=""
                                  />
                                </button> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7}>No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        page="Memmbership"
        show={show}
        handleShow={handleShow}
        cancel={() => {
          setShow(false);
        }}
        confirmDelete={confirmDelete}
      />
    </article>
  );
}

export default Membership;
